export function preRender(data, options) {
  const refX = findOffset(options);
  const width = arrowWidth(options.print);
  const midpoint = width / 2;
  const height = getHeight(width, midpoint);
  data.defs.markers.marker0 = {
    id: 'arrow',
    refY: midpoint,
    refX,
    children: [{
      tagName: 'path',
      attrs: {
        d: `M 0 0 L ${height} ${midpoint} L 0 ${width} Z`
      }
    }]
  };
}

export function arrowWidth(print) {
  return print ? 3.5 : 6.5;
}

export function findOffset(options) {
  let x = options.print ? 4.25 : 8.5;
  return x + (options.product === 'wsj' ? 4 : 0);
}

export function getHeight(width, midpoint) {
  return Math.sqrt(width * width - midpoint * midpoint);
}



// WEBPACK FOOTER //
// ./src/chart/inner/defs.js